import { useContext } from 'react';
import { ChartThemeProvider } from '@deephaven/chart';
import { MonacoThemeProvider } from '@deephaven/console';
import { isExternalThemeEnabled, ThemeProvider } from '@deephaven/components';
import { useAppSelector } from '@deephaven/dashboard';
import { IrisGridContextProvider } from '@deephaven/iris-grid';
import { PluginsContext, useCustomThemes } from '@deephaven/plugin';
import { getSettings } from '@deephaven/redux';
import { jsx as _jsx } from "react/jsx-runtime";
export function ThemeBootstrap(_ref) {
  var children = _ref.children;
  var settings = useAppSelector(getSettings);

  // The `usePlugins` hook throws if the context value is null. Since this is
  // the state while plugins load asynchronously, we are using `useContext`
  // directly to avoid the exception.
  var pluginModules = useContext(PluginsContext);
  var themes = useCustomThemes(pluginModules);
  var waitForActivation = isExternalThemeEnabled();
  return /*#__PURE__*/_jsx(ThemeProvider, {
    themes: themes,
    waitForActivation: waitForActivation,
    children: /*#__PURE__*/_jsx(ChartThemeProvider, {
      children: /*#__PURE__*/_jsx(MonacoThemeProvider, {
        children: /*#__PURE__*/_jsx(IrisGridContextProvider, {
          density: settings.gridDensity,
          children: children
        })
      })
    })
  });
}
export default ThemeBootstrap;
//# sourceMappingURL=ThemeBootstrap.js.map